import React from 'react';
import '../Poster/Poster.css';
import {Link} from 'react-router-dom'
const Poster = () => {
  return (
    <div className="poster-container">
      <div className="poster-overlay">
        <h1 className="poster-heading">Beginning of your travel Journey </h1>
        <Link to="/tour">
        <button className="poster-btn">Discover More</button>
        </Link>
      </div>
    </div>
  );
};

export default Poster;
